export const addToken = (token: string) => ({
    type: "ADD_TOKEN",
    token
})
